import type { AdPlatform } from "@yjsgames/house-ads";

export type OtherGamesStore = "google_play" | "app_store";

export const OTHER_GAMES_SOURCE = "settings_modal";
export const OTHER_GAMES_CAMPAIGN = "other_games";
export const OTHER_GAMES_TARGET = "developer_page";

export const OTHER_GAMES_DEVELOPER_URLS: Record<OtherGamesStore, string> = {
  google_play: "https://play.google.com/store/apps/dev?id=9126505555578543741",
  app_store: "https://apps.apple.com/kr/developer/yangjin-lee/id1868279559",
};

export function resolveOtherGamesStore(platform: AdPlatform): OtherGamesStore {
  return platform === "ios" ? "app_store" : "google_play";
}

export function withOtherGamesTracking(url: string, store: OtherGamesStore): string {
  const tracked = new URL(url);
  tracked.searchParams.set("utm_source", "module_brick_idle");
  tracked.searchParams.set("utm_medium", OTHER_GAMES_SOURCE);
  tracked.searchParams.set("utm_campaign", OTHER_GAMES_CAMPAIGN);
  tracked.searchParams.set("utm_content", store);
  return tracked.toString();
}

export function resolveOtherGamesUrl(platform: AdPlatform): {
  readonly store: OtherGamesStore;
  readonly url: string;
} {
  const store = resolveOtherGamesStore(platform);
  return { store, url: withOtherGamesTracking(OTHER_GAMES_DEVELOPER_URLS[store], store) };
}
